import React, { Component } from 'react';
import {
    PieChart,
    Pie,
    Cell,
    ResponsiveContainer,
    Tooltip,
} from 'recharts';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import IconSquareCustom from '../../assets/icons/IconSquareCustom';
import IconTicketCompletion from '../../assets/icons/IconTicketCompletion';

const COLORS = ["#2E90FC", "#FBCA2E", "#2155A3", "#FF6F00"];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
        <text className="font-bold" x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central">
            {`${(percent * 100).toFixed(2)}%`}
        </text>
    );
};

class TicketCompletionChart extends Component {
    checkColorComponent = (data, index) => {
        if (data.name === "0 Hari") {
            return COLORS[0];
        }
        if (data.name === "1 Hari") {
            return COLORS[1];
        }
        if (data.name === "2 Hari") {
            return COLORS[2];
        }
        if (data.name === "> 2 Hari") {
            return COLORS[3];
        }
    }

    render() {
        return (
            <>
                {/* Ticket by Resolution Time */}
                <div id="btnticketbyresolution" className="rounded-md shadow-lg col-span-3 bg-white" onClick={this.props.handlePopupTicketResolution}>
                    <div className="text-nexcareblue1 p-5">
                        <div className="text-xl font-bold flex items-center pb-5">
                            {
                                this.props.loading
                                    ? <Skeleton height={40} width={40} />
                                    : <IconTicketCompletion />
                            }
                            {
                                this.props.loading
                                    ? <Skeleton height={20} width={250} className="ml-2" />
                                    : <p className="pl-3">Tiket berdasarkan Waktu Penanganan</p>
                            }
                        </div>
                        {
                            this.props.loading
                                ? <Skeleton height={220} />
                                : <div>
                                    {
                                        this.props.data.length > 0
                                            ? <div className="flex">
                                                <div className="flex-auto w-4/12 font-medium text-lg">
                                                    <div className="flex items-center">
                                                        <IconSquareCustom squareColor="#2E90FC" className="mr-3" />
                                                        <span>{`0 Hari`}</span></div>
                                                    <div className="flex items-center">
                                                        <IconSquareCustom squareColor="#FBCA2E" className="mr-3" />
                                                        <span>{`1 Hari`}</span></div>
                                                    <div className="flex items-center">
                                                        <IconSquareCustom squareColor="#2155A3" className="mr-3" />
                                                        <span>{`2 Hari`}</span></div>
                                                    <div className="flex items-center">
                                                        <IconSquareCustom squareColor="#FF6F00" className="mr-3" />
                                                        <span>{`> 2 Hari`}</span>
                                                    </div>
                                                </div>
                                                <div className="flex-auto w-8/12 h-64">
                                                    <ResponsiveContainer height="120%">
                                                        <PieChart>
                                                            <Pie
                                                                data={this.props.data}
                                                                cx="40%"
                                                                cy="40%"
                                                                labelLine={false}
                                                                label={renderCustomizedLabel}
                                                                fill="#8884d8"
                                                                dataKey="value"
                                                            >
                                                                {this.props.data.map((entry, index) => (
                                                                    <Cell key={`cell-${index}`} fill={this.checkColorComponent(entry, index)} />
                                                                ))}
                                                            </Pie>
                                                            <Tooltip />
                                                        </PieChart>
                                                    </ResponsiveContainer>
                                                </div>
                                            </div>
                                            : <div className="flex justify-center items-center text-lg font-medium h-64">
                                                <p className="text-darkgrey">Tidak ada data</p>
                                            </div>
                                    }
                                </div>
                        }
                    </div>
                </div>
            </>
        );
    }
}

export default TicketCompletionChart;